module.exports = __webpack_public_path__ + "f66906430a5ce75bc0ee2eb81fa2617e.png";